// extracted by css-extract-rspack-plugin
export default {"cardContentFixedLabels":"DonationMatchRequestDetails_cardContentFixedLabels__zDZiT"};